import { IconHistory, IconUsers } from "@tabler/icons-react";
import { ModuleLanding, NoteText } from "../../shell/ModuleLanding";

export function AdminHome() {
  return (
    <ModuleLanding
      title="Admin"
      subtitle="Accounts and the audit trail"
      tiles={[
        {
          to: "/admin/users",
          label: "Users",
          blurb: "Create staff accounts, change roles, issue passwords",
          icon: <IconUsers size={21} stroke={1.6} />,
        },
        {
          to: "/admin/audit",
          label: "Audit trail",
          blurb: "Every recorded action, who did it and what changed",
          icon: <IconHistory size={21} stroke={1.6} />,
        },
      ]}
      noteTitle="How people sign in"
      note={
        <>
          <NoteText>
            Field staff — Marketing, Billing Executive, Delivery, Service —
            sign in with their mobile number and a one-time code, so their
            account needs a number and nothing else.
          </NoteText>
          <NoteText>
            Owner / Admin and Store Manager sign in with a username and
            password instead. Creating one of those issues a password that is
            shown <strong>once</strong> and is not recoverable — if it is lost,
            issue a new one.
          </NoteText>
        </>
      }
    />
  );
}
